/**
 * Find option with given id for select.
 */
export const findOption = (options, id) => {
    return [...flattenOptions(options)].find(o => o.value === id);
};

export const findOptionWithLabel = (options, id) => {
    return [...flattenOptions(options)].find(o => o.value === id || o.label === id);
};

/**
 * Find options with given id for multiselect to match value in options.
 */
export const findOptions = (options, ids) => {
    return ids && ids.length
        ? ids.sort()
            .map((id) => [...flattenOptions(options)].find((o) => o.value === id)) : [];
};

/**
 * Find options with given id for multiselect to match label in options.
 */
export const findOptionsWithLabel = (options, ids) => {
    return ids && ids.length
        ? ids.sort()
            .map((id) => [...flattenOptions(options)].find((o) => o.value === id || o.label === id)) : [];
};

/**
 * If the Select options has multiple grouping, flatten the groups to find selected option.
 * @param options
 * @returns options without grouping
 */
export const flattenOptions = (options) => {
    let flatOptions = [];
    for (let opt of options) {
        if (opt.hasOwnProperty('options')) {
            flatOptions.push(...flattenOptions(opt.options))
        } else {
            flatOptions.push(opt);
        }
    }
    return flatOptions;
}



// WEBPACK FOOTER //
// ./src/components/reports/utils/buttons.js